import {combineEpics, ofType, PledgerAction, PledgerEpic} from "@pledger/frontend-commons";
import {map} from "rxjs/operators";
import {ChangePhoneNumberActions} from "./ChangePhoneNumberActions";
import {ShowPageActions} from "../app/Pages/ShowPageActions";
import {changePhoneNumberWServiceActions} from "../../services/ws/changePhoneNumber/changePhoneNumberWServiceActions";

/*const emptyEpic : PledgerEpic<any> = (actions$ : Observable<PledgerAction>) => of(AppActions.EMPTY_ACTION.build());*/

const pageLoadedEpic : PledgerEpic<any> = (actions$) =>
    actions$.pipe(
        ofType(ChangePhoneNumberActions.CHANGE_PHONE_NUMBER_PAGE_LOADED_ACTION.type),
        map((action : PledgerAction) => {
            return changePhoneNumberWServiceActions.CHANGE_PHONE_NUMBER_GET_REQUEST_CODE_ACTION.build();
        }));

const newPhoneNumberRegisteredEpic : PledgerEpic<any> = (actions$) =>
    actions$.pipe(
        ofType(changePhoneNumberWServiceActions.CHANGE_PHONE_NUMBER_PUT_NEW_PHONE_NUMBER_VALIDATION_SUCCEEDED_ACTION.type),
        map((action : PledgerAction) => {
            return ShowPageActions.SHOW_ACCOUNT_ACTION.build(false);
        }));

export const changePhoneNumberEpics = combineEpics(
    pageLoadedEpic,
    newPhoneNumberRegisteredEpic

);
